import { Box } from '@mui/material';
import { ENV } from '../../constants';

const Video = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
    <Box
      sx={{
        width: { xs: '100%', sm: '80%', md: '600px' },
        my: { xs: 3, md: 8 },
      }}
      component='video'
      controls
    >
      <source
        src={`${ENV.CDN_BASE_URL_VIDEO}/content-page.mp4`}
        type='video/mp4'
      />
    </Box>
  </Box>
);

export default Video;
